<h1 class="logoPrincipal">
  <a [routerLink]="['']" alt="Siriema - Autorização Ambiental para Pesca Amadora ou Desportiva" title="Siriema - Autorização Ambiental para Pesca Amadora ou Desportiva">
    <img src="assets/img/siriema.png" alt="Siriema - Autorização de Pesca Amadora ou Desportiva"/>
  </a>
  Autorização Ambiental para Pesca Amadora<br/> ou Desportiva
</h1>